import * as factory from "../../../../nodeFactory";
import { getNodeById } from "../../../../nodeSelector";
import * as pathUtils from "../../../../utils/pathUtils";
import * as typeUtils from "../../../../utils/typeUtils";
import { addParameter } from "../addParameter";

export const addParameterAdapter = (root, id, parType, relVertical) => {
  const _isTop = pathUtils.isFunction(id) || pathUtils.isRoot(id);

  if (_isTop || relVertical) {
    return addToTop(root, id, parType);
  } else {
    return addToTarget(root, id, parType);
  }
};

const addToTop = (root, idParent, type) => {
  const _body =
    type === typeUtils.getTypeParameterOutput()
      ? factory.createOutputParameter(idParent)
      : factory.createInputParameter(idParent);

  return addParameter(root, idParent, _body);
};

const addToTarget = (root, idSibling, type) => {
  const _idParent = pathUtils.getIdParent(idSibling);
  const { index: _index } = getNodeById(root, idSibling);
  const _body =
    type === typeUtils.getTypeParameterOutput()
      ? factory.createOutputParameter(_idParent)
      : factory.createInputParameter(_idParent);

  return addParameter(root, _idParent, _body, _index);
};
